import Section from '@widgets/components/section';
import { Table, TableBody, TableTd, TableTh, TableThead, TableTr } from '@widgets/table';
import { formatNum } from '@app/utils/math';
import { GRADE, GradeBadge, TextSize, Typography } from '@shared/index';
import clsx from 'clsx';
import { useGetManagersTeamTable } from '@entities/managers-perfomance';

type GradeType = (typeof GRADE)[keyof typeof GRADE];

export const ManagersTeamTable = () => {
  const { data: managers } = useGetManagersTeamTable();

  const tableData =
    managers?.map(manager => ({
      name: manager.manager_name,
      managerId: manager.manager_id,
      dateJoined: manager.date_joined,
      clientsCount: manager.clients_count,
      hashrate: manager.hashrate,
      grade: manager.grade,
      team: manager.team,
    })) ?? [];

  const formatDate = (value?: string) => {
    if (!value) return '-';

    const parts = value.split(/[-.]/).map(Number);
    const [day, month, year] = parts;

    if ([day, month, year].some(Number.isNaN)) return value;

    return new Date(year, month - 1, day).toLocaleDateString('ru-RU');
  };

  return (
    <Section>
      <div className="flex items-center justify-between w-full mb-3">
        <Typography size={TextSize.size24} title="Менеджеры" className="font-semibold" />
      </div>
      <div className="overflow-y-auto max-h-[410px]">
        <Table>
          <TableThead className="text-white/40 [&_div]:justify-start">
            <TableTr withoutUnderline>
              <TableTh title="Имя" className="w-[20%]" />
              <TableTh title="Дата начала работы" className="w-[25%]" />
              <TableTh title="Общий хешрейт" className="w-[15%]" />
              <TableTh title="Кол-во клиентов" className="w-[15%]" />
              <TableTh title="Команда" className="w-[15%]" />
              <TableTh title="Грейд" className="w-[10%]" />
            </TableTr>
          </TableThead>
          <TableBody>
            {tableData.map((item, index) => {
              const isOdd = index % 2 === 0;

              return (
                <TableTr
                  key={item.managerId}
                  style={{ backgroundColor: isOdd ? '#1D1D1D' : 'unset' }}
                  withoutUnderline
                >
                  <TableTd
                    title={
                      <div className="flex items-center gap-2">
                        <span>{item.name}</span>
                      </div>
                    }
                    className={clsx(isOdd && 'rounded-l-[16px]')}
                  />
                  <TableTd title={formatDate(item.dateJoined)} />
                  <TableTd title={formatNum(item.hashrate)} />
                  <TableTd title={formatNum(item.clientsCount)} />
                  <TableTd title={item.team ?? '—'} />
                  <TableTd
                    title={<GradeBadge grade={item.grade as GradeType} />}
                    className={clsx(isOdd && 'rounded-r-[16px]')}
                  />
                </TableTr>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Section>
  );
};
